const danhSachTemplate = (state) => state.danhSachTemplate;
const chiTietTemplate = (state) => state.chiTietTemplate;
const danhSachQuanLyHeThongLog = (state) => state.danhSachQuanLyHeThongLog;
const danhSachQuanLyHeThongCRUD = (state) => state.danhSachQuanLyHeThongCRUD;

export default {
  danhSachTemplate,
  chiTietTemplate,
  danhSachQuanLyHeThongLog,
  danhSachQuanLyHeThongCRUD,
};
